export default async function executeViaExecutor({
  params,
  pkp,
  orderType,
  cloudWallet,
  dbOrderParams,
  transferParams
}) {
  const url = '/api/lit/execute-user-order';
  const response = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      orderType,
      params,
      pkp,
      cloudWallet,
      dbOrderParams,
      transferParams
    })
  });
  const data = await response.json();
  if (data.error) {
    return {
      error: data.error
    };
  }
  return data;
}